export default __webpack_public_path__ + "static/media/fingertips-img.9d8b24ee.png";